import { useEffect, useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../lib/firebase";
import { useLang } from "../../lib/useLang";
import { fetchMenuItems, isBackendConfigured } from "../../lib/catalog";
import { CATEGORY_META } from "../../data/menu";
import type { MenuItem } from "../../lib/types";

export default function StandingMenuAdmin() {
  const { t, pick } = useLang();
  const [items, setItems] = useState<MenuItem[]>([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    fetchMenuItems().then(setItems);
  }, []);

  function update(id: string, patch: Partial<MenuItem>) {
    setItems((arr) => arr.map((x) => (x.id === id ? { ...x, ...patch } : x)));
  }

  async function save(item: MenuItem) {
    if (isBackendConfigured) {
      await updateDoc(doc(db, "menuItems", item.id), {
        price: item.price,
        active: item.active,
      });
    }
    setStatus(item.id);
    setTimeout(() => setStatus(""), 1500);
  }

  return (
    <div className="space-y-5">
      {CATEGORY_META.map((cat) => {
        const catItems = items.filter((i) => i.category === cat.key);
        if (!catItems.length) return null;
        return (
          <section key={cat.key}>
            <h3 className="mb-2 font-bold text-gray-900">{pick(cat.en, cat.ar)}</h3>
            <div className="space-y-1.5">
              {catItems.map((it) => (
                <div
                  key={it.id}
                  className="grid grid-cols-[1fr_5rem_3rem_auto] items-center gap-2 rounded-xl bg-white p-2 ring-1 ring-black/5"
                >
                  <span className="truncate text-sm font-medium">
                    {pick(it.name, it.nameAr)}
                  </span>
                  <input
                    className="input py-1.5"
                    type="number"
                    step="0.05"
                    min="0"
                    value={it.price}
                    onChange={(e) => update(it.id, { price: Number(e.target.value) })}
                  />
                  <input
                    type="checkbox"
                    className="h-5 w-5 accent-brand"
                    checked={it.active}
                    onChange={(e) => update(it.id, { active: e.target.checked })}
                  />
                  <button
                    className="btn-outline px-2.5 py-1 text-xs"
                    onClick={() => save(it)}
                  >
                    {status === it.id ? "✔" : t("admin.save")}
                  </button>
                </div>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
